/* Gesicht auf Socken – Foto-Tipps als Pop-up auf Produkt- und Kissen-Seiten (eingebunden in sh-main-product und
   sh-main-cushion; Stile .shp-tipsdlg in sh-base.css). */
(function () {
  'use strict';

  /* Foto-Tipps als Pop-up (Joel 2026-10-15: Kunden nicht vom Kauf auf eine andere Seite lenken). Links auf
     „…#foto-tipps“ öffnen den Abschnitt „So gelingt das perfekte Foto“ der FAQ-Seite in einem Dialog. Der Inhalt wird
     beim ersten Öffnen von dort geladen (eine Quelle, Pflege im Theme-Editor auf der FAQ-Seite), dazu sh-pages.css.
     Klappt das nicht, öffnet sich der Link wie bisher. */
  var tipsUi = null;

  function loadTips(url, id, ui) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('tips ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sec = doc.getElementById(id);
      if (!sec) throw new Error('tips');
      var css = [];
      doc.querySelectorAll('link[rel="stylesheet"][href*="sh-pages"]').forEach(function (l) {
        var href = l.getAttribute('href');
        if (document.querySelector('link[href="' + href + '"]')) return;
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        css.push(new Promise(function (done) { link.onload = link.onerror = done; setTimeout(done, 3000); }));
        document.head.appendChild(link);
      });
      return Promise.all(css).then(function () {
        sec.removeAttribute('id');
        ui.body.innerHTML = '';
        ui.body.appendChild(document.importNode(sec, true));
        var h = ui.body.querySelector('h2');
        if (h) {
          h.id = 'ShpTipsTitle';
          ui.dialog.setAttribute('aria-labelledby', 'ShpTipsTitle');
        }
      });
    });
  }

  function openTips(link) {
    if (!tipsUi) {
      var d = document.createElement('dialog');
      d.className = 'shp-tipsdlg';
      d.setAttribute('aria-label', 'Foto-Tipps');
      d.innerHTML = '<button type="button" class="shp-tipsdlg__close" aria-label="Schließen" data-tips-close>' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="shp-tipsdlg__body" data-tips-body><p class="shp-tipsdlg__load">Foto-Tipps werden geladen …</p></div>' +
        '<div class="shp-tipsdlg__foot"><button type="button" class="sh-btn sh-btn--primary sh-btn--block" data-tips-close>Zurück zum Gestalten</button></div>';
      document.body.appendChild(d);
      // Schließen über die Knöpfe oder einen Klick neben den Dialog
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.closest('[data-tips-close]')) d.close();
      });
      tipsUi = { dialog: d, body: d.querySelector('[data-tips-body]'), loaded: null };
    }
    var ui = tipsUi;
    var url = new URL(link.href, location.href);
    var id = decodeURIComponent(url.hash.slice(1)) || 'foto-tipps';
    url.hash = '';
    if (!ui.loaded) {
      ui.loaded = loadTips(url.href, id, ui);
      ui.loaded.catch(function () { ui.loaded = null; });
    }
    ui.dialog.showModal();
    ui.loaded.catch(function () {
      ui.dialog.close();
      location.href = link.href;
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="#foto-tipps"]') : null;
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof HTMLDialogElement !== 'function' || !window.fetch || !window.DOMParser) return;
    e.preventDefault();
    openTips(a);
  });
})();
